import ColorPicker from "components/ColorPicker";
import { InPageEditableStandaloneField } from "components/MainSectionTemplate/InPageEditableStandaloneField";
import OptionalTextInput from "components/ValidatedFields/OptionalTextInput";
import React from "react";
import { createMergefieldPath } from "./utils";

interface Props {
  column: server.dto.ExcelTemplateColumn
  avaiableMergeFieldTopics: server.dto.AvailableMergeFieldTopic[]
  onSave: (column: server.dto.ExcelTemplateColumn) => void
}

export const ColumnsRow = (props: Props) => {
  const mergefieldPath = createMergefieldPath(props.avaiableMergeFieldTopics, props.column.mergeField);
  const mergefieldNotFound = mergefieldPath == null;

  if (mergefieldNotFound) {
    return null;
  }

  const onColorChange = (newColor: string) => {
    props.onSave({
      ...props.column,
      hexColor: newColor
    });
  }

  return <>
    <div>
      <ColorPicker value={props.column.hexColor} onChange={onColorChange} />
    </div>
    <div className="grow1">
      <InPageEditableStandaloneField
        value={props.column.headerLabel || ""}
        onValueUpdated={newVal => {
          props.onSave({
            ...props.column,
            headerLabel: newVal.trim().length === 0 ? null : newVal
          });
        }}
        render={() => <span className="h3">
          {props.column.headerLabel || props.column.mergeField}
          {props.column.headerLabel && <span className="s1_gray">&nbsp;({props.column.mergeField})</span>}
        </span>}
        renderEdit={({ value, onChange, submit, cancel }) => <OptionalTextInput
          focusOnMount
          value={value}
          maxLength={serverReference.constants.excelTemplate.maxMergeFieldIdLength}
          onChange={onChange}
          onEnter={submit}
          onEsc={cancel}
        />}
      />
      <div>{mergefieldPath}</div>
    </div>
  </>
}